import { LEXON_API_URL } from 'src/config'
import { Contact } from 'src/interfaces/lexon'
import lexonFormHttp from 'src/utils/Http/LexonFormHttp'

const CONTACTS_LIST = `${LEXON_API_URL}/contacts/all/get`

export interface GetContactsResponse {
  tableHeaders: any[]
  items: Contact[]
}

const CONTACTS_TABLE_HEADERS = ['name', 'type', 'email', 'mobilePhone', 'phone']
const CONTACTS_PAGE_SIZE = 0

export async function getContacts(source = 'lexnet'): Promise<GetContactsResponse> {
  return lexonFormHttp
    .post({
      url: `${CONTACTS_LIST}`,
      params: { source, pageSize: CONTACTS_PAGE_SIZE, page: 1 }
    })
    .then(res => ({
      items: res.data?.contacts ?? res.data ?? [],
      tableHeaders: CONTACTS_TABLE_HEADERS
    }))
}
